import { Routes, Route } from 'react-router-dom'
import { AppWrapper } from '@/components/AppWrapper'
import { Toaster } from 'react-hot-toast'
import Home from '@/pages/Home'
import Browse from '@/pages/Browse'
import TopAnime from '@/pages/TopAnime'
import Genres from '@/pages/Genres'
import Genre from '@/pages/Genre'
import AnimeDetail from '@/pages/AnimeDetail'
import Watch from '@/pages/Watch'
import SignIn from '@/pages/SignIn'
import SignUp from '@/pages/SignUp'

function App() {
  return (
    <div className="bg-dark-400 text-white min-h-screen">
      <AppWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/top-anime" element={<TopAnime />} />
          <Route path="/genres" element={<Genres />} />
          <Route path="/genre/:slug" element={<Genre />} />
          <Route path="/anime/:id" element={<AnimeDetail />} />
          <Route path="/watch/:id" element={<Watch />} />
          <Route path="/auth/signin" element={<SignIn />} />
          <Route path="/auth/signup" element={<SignUp />} />
        </Routes>
      </AppWrapper>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151',
          },
        }}
      />
    </div>
  )
}

export default App
